import { Outlet } from "react-router-dom";
import { LogoutModal } from "../../features/auth/components/LogoutModal";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

export function AppLayout(): JSX.Element {
  return (
    <div className="grid h-dvh grid-rows-[auto_minmax(0,1fr)] overflow-hidden bg-white">
      <TopBar />
      <div className="flex min-h-0 overflow-hidden">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <main className="flex-1 overflow-y-auto p-3 sm:p-4 md:p-6">
            <Outlet />
          </main>
        </div>
      </div>
      <LogoutModal />
    </div>
  );
}
